import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PageNavigationProps {
  currentPage: number;
  currentChapter: number;
  chapterLockStatus: Record<number, boolean>;
  onPageChange: (direction: 'prev' | 'next') => void;
}

export const PageNavigation: React.FC<PageNavigationProps> = ({
  currentPage,
  currentChapter,
  chapterLockStatus,
  onPageChange
}) => {
  return (
    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-4">
      <button
        className="group flex items-center gap-2 px-6 py-3 bg-gray-900/80 hover:bg-gray-800
                   border border-gray-800 hover:border-purple-500/50 rounded-lg transition-all duration-300
                   text-gray-400 hover:text-purple-400 font-mono text-sm backdrop-blur-sm"
        onClick={() => onPageChange('prev')}
        style={{
          boxShadow: '0 0 20px rgba(0,0,0,0.2)',
          textShadow: '0 0 10px rgba(168,85,247,0.3)'
        }}
      >
        <ChevronLeft className="w-4 h-4 group-hover:animate-pulse" />
        <span>PREV_PAGE</span>
      </button>

      <div className="px-4 py-2 bg-gray-900/50 rounded-lg border border-gray-800 font-mono text-sm">
        <span className="text-gray-500">PAGE_</span>
        <span className="text-purple-400">{String(currentPage).padStart(2, '0')}</span>
      </div>

      <button
        className="group flex items-center gap-2 px-6 py-3 bg-gray-900/80 hover:bg-gray-800
                   border border-gray-800 hover:border-purple-500/50 rounded-lg transition-all duration-300
                   text-gray-400 hover:text-purple-400 font-mono text-sm backdrop-blur-sm"
        onClick={() => onPageChange('next')}
        disabled={chapterLockStatus[currentChapter + 1]}
        style={{
          boxShadow: '0 0 20px rgba(0,0,0,0.2)',
          textShadow: '0 0 10px rgba(168,85,247,0.3)'
        }}
      >
        <span>NEXT_PAGE</span>
        <ChevronRight className="w-4 h-4 group-hover:animate-pulse" />
      </button>
    </div>
  );
};
